import { emptyValidator, formValidator } from "../../validators";

const chargeTypeValidationStatus = {
  chtCharge: {
    validators: [emptyValidator()],
    name: "Charge Type",
  },
  chtEv: {
    validators: [emptyValidator()],
    name: "Ev",
  },
  chtPercentage: {
    validators: [emptyValidator()],
    name: "Percentage",
  },
  chtInvoice: {
    validators: [emptyValidator()],
    name: "Invoice",
  },
  chtStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  chtActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
  chtItemCatogery: {
    validators: [emptyValidator()],
    name: "Item Catogery",
  },
  chtNegotiation: {
    validators: [emptyValidator()],
    name: "Negotiation Type",
  },
  chtQtyCharge: {
    validators: [emptyValidator()],
    name: "Quantity Charge",
  },

  chtTransporters:{
    validators: [emptyValidator()],
    name: "Transporter",
  }
};

export const chargeTypeFormValidator = (chargeType) => {
  return formValidator(chargeType, chargeTypeValidationStatus);
  
};
